export const PLAYBACK_BAR_HEIGHT = 85; // In px
export const MOBILE_PLAYBACK_BAR_HEIGHT = 65; // In px
export const EXTENDED_HEADER_HEIGHT = 100; // In px
export const HEADER_HEIGHT = 80; // In px
export const MOBILE_HEADER_HEIGHT = 50; // In px
export const MOBILE_EXTENDED_HEADER_HEIGHT = 130; // In px
export const MOBILE_MEDIUM_HEADER_HEIGHT = 80; // In px